import React from 'react';
import { Skeleton } from 'gatorcomponents';

const ProtectionCardSkeleton = ({
  width = '534px', height = '205px', isVisible = true, testId = 'protection-card-skeleton',
}) => (
  <Skeleton width={width} height={height} isVisible={isVisible} testId={testId} data-component="ProtectionCardSkeleton" />
);

export default ProtectionCardSkeleton;
